module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "informTimeMod"
  }, [_c('div', {
    staticClass: "dialogueModContent"
  }, [_c('div', {
    staticClass: "contentTime"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("\n        " + _vm._s(_vm.timeFn) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ContentMid clear"
  }, [_c('div', {
    staticClass: "midLeft"
  }, [_c('span', {
    staticClass: "leftImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "midRight"
  }, [_c('span', {
    staticClass: "rightArrows"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abc4e93a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/informTimeMod/src/informTimeMod.vue
// module id = 560
// module chunks = 0